import { Controller } from "@hotwired/stimulus"

// Controller for monitoring batch research job status
export default class extends Controller {
  static values = { 
    refreshInterval: { type: Number, default: 5000 },
    jobId: String 
  }

  connect() {
    this.startPolling()
  }

  disconnect() {
    this.stopPolling()
  }

  startPolling() {
    if (!this.jobIdValue) return
    
    this.refreshTimer = setInterval(() => {
      this.checkStatus()
    }, this.refreshIntervalValue)
    
    // Check immediately
    this.checkStatus()
  }

  stopPolling() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
      this.refreshTimer = null
    }
  }

  async checkStatus() {
    try {
      const response = await fetch(`/admin/venue-research/batch-status/${this.jobIdValue}`, {
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })

      if (!response.ok) {
        throw new Error('Failed to fetch batch status')
      }

      const data = await response.json()
      
      if (data.status === 'completed' || data.status === 'failed') {
        this.stopPolling()
        
        // Reload the page to show updated results
        if (data.status === 'completed') {
          window.location.reload()
        }
      }
      
      // Update progress UI if still processing
      if (data.status === 'processing') {
        this.updateProgress(data)
      }
    } catch (error) {
      console.error('Error checking batch status:', error)
    }
  }

  updateProgress(data) {
    const progressBar = this.element.querySelector('.bg-blue-600')
    if (progressBar) {
      const percentage = (data.processed / data.total * 100).toFixed(0)
      progressBar.style.width = `${percentage}%`
    }

    const statusText = this.element.querySelector('.text-blue-700')
    if (statusText) {
      statusText.textContent = `Processing ${data.processed} of ${data.total} venues`
    }
  }
}